import React from "react";
import RegistrationForm from "../../Components/RegistrationForm/RegistrationForm";
import "./ErrorPage.css";
import { Helmet } from "react-helmet-async";

class ErrorPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: "",
    };

    this.handlePrimaryButton = this.handlePrimaryButton.bind(this);
  }

  handlePrimaryButton() {
    localStorage.clear();
    this.props.history.push("/");
  }

  componentDidMount() {
    if (this.props.location.state) {
      if (this.props.location.state.error) {
        this.setState({
          error: this.props.location.state.error,
        });
      }
    } else {
      this.props.history.push("/");
    }
  }

  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Astronomic Network</title>
          <meta
            name="description"
            content="Austin entrepreneurs helping each other win"
          />
        </Helmet>

        {this.state.error !== "" ? (
          <RegistrationForm
            containerClassName="container-error-page"
            hasCounter={false}
            hasQuote={true}
            quote={this.state.error}
            headerText="Oops!"
            primaryButtonText="Back to home"
            hasSkip={false}
            handlePrimaryBtnOnClick={this.handlePrimaryButton}
            activatePrimaryWithEnter={true}
            showButton={true}
            showBackButton={false}
          ></RegistrationForm>
        ) : (
          <RegistrationForm
            containerClassName="container-error-page"
            hasCounter={false}
            hasQuote={true}
            quote="Something went wrong."
            headerText="Oops!"
            primaryButtonText="Back to home"
            hasSkip={false}
            handlePrimaryBtnOnClick={this.handlePrimaryButton}
            showButton={true}
            showBackButton={false}
          ></RegistrationForm>
        )}
      </React.Fragment>
    );
  }
}

export default ErrorPage;
